import { SvgIcon } from '../../shared-interfaces';

const svgIcons: SvgIcon[] = [
  { name: 'p-payer-plan', file: 'payer-plan.svg' },
  { name: 'p-payer-lob', file: 'payer-lob.svg' },
  { name: 'p-payer-user', file: 'payer-users.svg' },
  { name: 'p-work-basket', file: 'work-basket.svg' },
  { name: 'p-icon-video', file: 'icon-video.svg' },
  { name: 'p-icon-faqs', file: 'icon-faqs.svg' },
  { name: 'p-icon-provider-white', file: 'icon-provider-white.svg' },
  { name: 'p-icon-provider', file: 'icon-provider.svg' },
  { name: 'p-icon-facilities', file: 'icon-Facility.svg' },
  { name: 'p-icon-single-user', file: 'icon-single-user.svg' },
  { name: 'p-icon-user-roles', file: 'icon-user-roles.svg' },
  { name: 'p-icon-fee-scheduled', file: 'icon-FeeSched.svg' },
  { name: 'p-icon-history', file: 'Icon-History.svg' },
  { name: 'p-icon-malpractice-claims', file: 'Icon-Malpractice_Claims.svg' },
  { name: 'p-icon-org-contract', file: 'Icon-Org_Contract.svg' },
  { name: 'p-icon-ownership', file: 'Icon-Ownership.svg' },
  { name: 'p-icon-subcontractors', file: 'Icon-Subcontractors.svg' },
  { name: 'p-icon-verification', file: 'Icon-Verifications_Bundles.svg' },
  { name: 'p-icon-background-check', file: 'Icon-Background_Checks.svg' },
  { name: 'p-icon-committee-review', file: 'Icon-Committee_Reviews.svg' },
  { name: 'p-icon-payer-lob', file: 'Icon-Direct_Payer_Contracts_LOB.svg' },
  { name: 'p-icon-geo-alt', file: 'geo-alt.svg' },
  { name: 'p-icon-question-circle', file: 'question-circle.svg' },
  { name: 'p-icon-order-mgmt', file: 'icon-OrderManagement.svg' },
  { name: 'p-icon-billing', file: 'icon-Billing.svg' },
  { name: 'p-icon-flag', file: 'icon-flag.svg' },
  { name: 'p-icon-flag-white', file: 'icon-flag-white.svg' },
  { name: 'p-icon-split-white', file: 'icon-split-white.svg' },
  { name: 'p-icon-deposit', file: 'icon-deposit.svg' },
  { name: 'p-icon-recon-applied', file: 'icon-ReconcileApplied.svg' },
  { name: 'p-icon-recon-oneoff', file: 'icon-ReconcileOneOff.svg' },
  { name: 'p-icon-recon-unapplied', file: 'icon-ReconcileUnapplied.svg' },
  { name: 'p-icon-recon-job', file: 'icon-Reconcile.svg' },
  { name: 'p-icon-config-on-hold', file: 'icon-ConfigOnHold.svg' },
  { name: 'p-icon-include-exclude', file: 'icon-IncludeExclude.svg' },
  { name: 'p-icon-inclusion-data', file: 'icon-InclusionData.svg' },
  { name: 'p-icon-exclusion-data', file: 'icon-ExclusionData.svg' },
  { name: 'p-icon-remittance-advice', file: 'icon-RemittanceAdvice.svg' },
  { name: 'p-icon-claims', file: 'icon-claims.svg' },
  { name: 'p-icon-gem-fade', file: 'icon-prism-logo-fade.svg' },
];

  export default svgIcons;